import React from 'react';

function CheckboxIcon({disabled, value, reversed = false, lightUi = false}) {
  const enabledColor = reversed
          ? '#E0E0E0'
          : '#404040',
        disabledColor = reversed
          ? 'rgba(224,224,224,0.25)'
          : '#D8D8D8',
        lightUiColor = '#9D9D9C';

  return (disabled
    ? (
      // Disabled
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18">
          <path fill={disabledColor} d="M18,18H0V0h18V18z"/>
        </svg>
    ) : (value
      ? (
        // Checked
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18">
          <path fill={lightUi ? lightUiColor : enabledColor} d="M8.6,12.4L8.6,12.4L8.6,12.4L5.4,9.2l1.3-1.3l1.9,1.9L12.4,6l1.3,1.3L8.6,12.4z M0,18h18V0H0V18z"/>
        </svg>
      ) : (
        // Unchecked
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18">
          <path fill={lightUi ? lightUiColor : enabledColor} d="M18,18H0V0h18V18z M2,16h14V2H2V16z"/>
        </svg>
      )
    )
  );
}

export default CheckboxIcon;



// WEBPACK FOOTER //
// ./src/components/icons/CheckboxIcon.js